import React from 'react';

import { ChipProps } from '@mui/material';

import { ScheduleStatus, TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import Chip from 'components/Chip';
import { VatixChipProps } from 'components/Chip/types';
import { colors } from 'theme/colors';

const StatusChipPropsMapping: Record<string, VatixChipProps> = {
  [TaskStatus.CantDo]: {
    colors: {
      background: colors.grey[300],
      foreground: colors.common.black,
    },
    label: 'On hold',
  },
  [TaskStatus.Completed]: {
    colors: {
      background: '#c0d8c1',
      foreground: colors.common.black,
    },
    label: 'Completed',
  },
  [TaskStatus.InProgress]: {
    colors: {
      background: 'rgba(237, 108, 2, 0.3)',
      foreground: colors.common.black,
    },
    label: 'In progress',
  },
  [TaskStatus.ToDo]: {
    colors: {
      background: 'rgba(7, 114, 229, 0.12)',
      foreground: colors.common.black,
    },
    label: 'To do',
  },
  [ScheduleStatus.Overdue]: {
    colors: {
      background: 'rgba(211, 47, 47, 0.30)',
      foreground: '#000000',
    },
    label: 'Overdue',
  },
  [ScheduleStatus.Upcoming]: {
    colors: {
      background: '#E0E0E0',
      foreground: '#000000',
    },
    label: 'Upcoming',
  },
  [ScheduleStatus.WontDo]: {
    colors: {
      background: '#757575',
      foreground: '#fff',
    },
    label: "Won't Do",
  },
} as const;

const TaskStatusChip: React.FunctionComponent<{ status: TaskStatus | ScheduleStatus } & ChipProps> = ({
  status,
  ...props
}): React.ReactElement => (
  <Chip id={`task-status-${status}`} size={props.size || 'medium'} {...StatusChipPropsMapping[status]} {...props} />
);

export default TaskStatusChip;
